// React
import { ReactElement, ElementType } from "react";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

type CustomActionProps = {
	CustomComponent?: ElementType;
	onClick: () => void;
	disabled: boolean;
	hide: boolean;
	icon: ReactElement;
};

export default function CustomAction(props: Readonly<CustomActionProps>) {
	const { CustomComponent, ...restProps } = props;
	const { onClick, disabled, icon } = restProps;
	const onClickHandler = () => {
		onClick();
	};

	if (CustomComponent) {
		return <CustomComponent {...restProps} />;
	}

	return <SimpleIconButton onClick={onClickHandler} disabled={disabled} icon={icon} />;
}
